<template>
  <div class="ruleRight">
    <!-- 操作按钮 -->

    <!-- 右侧表格 -->
    <div class="rightTable">
      <div class="top">
        <div class="half">
          <div class="title">按构件类别设置图层</div>
          <el-table class="table" :data="buildingTypeTableData" height="295" highlight-current-row border="">
            <el-table-column align="center" type="index" label="序号" width="60"> </el-table-column>
            <el-table-column align="center" prop="specName" label="专业" width="120px"> </el-table-column>
            <el-table-column align="center" prop="familyCategoryName" label="族类型"> </el-table-column>
            <el-table-column align="center" prop="layerName" label="图层" width="150px">
              <template #default="{ row }">
                <el-select v-model="row.layerId" placeholder="请选择" filterable clearable size="small" @change="layerChange($event, row)">
                  <el-option v-for="item in layer[row.specId]" :key="item.layerId" :value="item.layerId" :label="item.layerName"></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="colour" label="颜色">
              <template #default="{ row }">
                <span v-if="row.colour !== null" class="colorBlock" :class="'color' + row.colour"></span>
                <span>
                  {{ row.colour }}
                </span>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="lineTypeName" label="线型"> </el-table-column>
          </el-table>
        </div>
        <div class="half">
          <div class="title">按关键字设置图层(比按构件类别有更高的优先级)</div>
          <el-table
            ref="keywordDom"
            class="table"
            height="250"
            highlight-current-row
            border=""
            :data="keywordTableData"
            @row-click="handleTablerowClick($event, 0)"
          >
            <el-table-column align="center" type="index" label="序号" width="60"> </el-table-column>
            <el-table-column align="center" prop="specId" label="专业" width="120px">
              <template #default="{ row }">
                <el-select v-model="row.specId" placeholder="请选择" clearable size="small" @change="specChange($event, row)">
                  <el-option v-for="num in professionalList" :key="num.specId" :value="num.specId" :label="num.specName"></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="filterConditionId" label="过滤规则" width="140px">
              <template #default="{ row }">
                <el-select v-model="row.filterConditionId" placeholder="请选择" clearable size="small" @change="filterRuleChange($event, row)">
                  <el-option v-for="num in filterList" :key="num.id" :value="num.id" :label="num.cnName"></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="inputValue" label="关键字" width="130px">
              <template #default="{ row }">
                <el-input v-model="row.inputValue" type="text" size="small"></el-input>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="layerId" label="图层" width="150px">
              <template #default="{ row }">
                <el-select v-model="row.layerId" placeholder="请选择" filterable clearable size="small" @change="layerChange($event, row)">
                  <el-option v-for="item in layer[row.specId]" :key="item.layerId" :value="item.layerId" :label="item.layerName"></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="colour" label="颜色">
              <template #default="{ row }">
                <span v-if="row.colour !== null" class="colorBlock" :class="'color' + row.colour"></span>
                <span>
                  {{ row.colour }}
                </span>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="lineTypeName" label="线型"> </el-table-column>
          </el-table>
          <div class="operator">
            <el-button type="primary" size="small" plain @click="addTableData(0)">新增</el-button>
            <el-button type="danger" size="small" plain @click="handleDelKeywordTable(0)">删除</el-button>
            <el-button size="small" @click="handleMove()">上移</el-button>
            <el-button size="small" @click="handleMove(true)">下移</el-button>
          </div>
        </div>
      </div>
      <div class="bottom">
        <div class="third">
          <div class="title">管道系统图层设置</div>
          <el-table
            ref="pipeLineDom"
            :data="pipelineTableData"
            style="width: 100%; margin-bottom: 20px"
            class="pipeLine"
            row-key="ruleDetailsId"
            height="290"
            border
            highlight-current-row
            :span-method="secondLayoutSpanMethod"
            :expand-row-keys="pipelineExpandKeys"
            @row-click="handleTablerowClick($event, 1)"
          >
            <el-table-column align="left" prop="frontDisplayName" label="类型" min-width="120px">
              <template #default="{ row }">
                <span v-if="!row.isEdit">{{ row.frontDisplayName }}</span>
                <el-input v-else v-model="row.frontDisplayName" :class="'input' + row.ruleDetailsId" style="width: 80%" size="small"></el-input>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="layerId" label="图层" width="150px">
              <template #default="{ row }">
                <el-select v-model="row.layerId" placeholder="请选择" filterable clearable size="small" @change="layerChange($event, row)">
                  <el-option v-for="item in layer[row.specId]" :key="item.layerId" :value="item.layerId" :label="item.layerName"></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="colour" label="颜色">
              <template #default="{ row }">
                <span v-if="row.colour !== null" class="colorBlock" :class="'color' + row.colour"></span>
                <span>
                  {{ row.colour }}
                </span>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="lineTypeName" label="线型"> </el-table-column>
          </el-table>
          <div class="operator">
            <el-button type="primary" size="small" plain @click="addTableData(1)">新增</el-button>
            <el-button type="danger" size="small" plain @click="handleDelKeywordTable(1)">删除</el-button>
          </div>
        </div>

        <div class="third">
          <div class="title">风管系统图层设置</div>
          <el-table
            ref="airLineDom"
            :data="airLineTableData"
            style="width: 100%; margin-bottom: 20px"
            class="airLine"
            row-key="ruleDetailsId"
            border
            highlight-current-row
            height="290"
            :span-method="firstLayoutSpanMethod"
            :expand-row-keys="airLineExpandKeys"
            @row-click="handleTablerowClick($event, 2)"
          >
            <el-table-column align="center" prop="frontDisplayName" label="类型" min-width="120px">
              <template #default="{ row }">
                <span v-if="!row.isEdit">{{ row.frontDisplayName }}</span>
                <el-input v-else v-model="row.frontDisplayName" :class="'input' + row.ruleDetailsId" style="width: 80%" size="small"></el-input>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="layerId" label="图层" width="150px">
              <template #default="{ row }">
                <el-select v-model="row.layerId" placeholder="请选择" filterable clearable size="small" @change="layerChange($event, row)">
                  <el-option v-for="item in layer[row.specId]" :key="item.layerId" :value="item.layerId" :label="item.layerName"></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="colour" label="颜色">
              <template #default="{ row }">
                <span v-if="row.colour !== null" class="colorBlock" :class="'color' + row.colour"></span>
                <span>
                  {{ row.colour }}
                </span>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="lineTypeName" label="线型"> </el-table-column>
          </el-table>
          <div class="operator">
            <el-button type="primary" size="small" plain @click="addTableData(2)">新增</el-button>
            <el-button type="danger" size="small" plain @click="handleDelKeywordTable(2)">删除</el-button>
          </div>
        </div>

        <div class="third">
          <div class="title">电缆桥架图层设置</div>
          <el-table
            ref="cableBridgeDom"
            :data="cableBridgeTableData"
            style="width: 100%; margin-bottom: 20px"
            class="pipeLine"
            row-key="ruleDetailsId"
            border
            height="290"
            highlight-current-row
            :span-method="secondLayoutSpanMethod2"
            :expand-row-keys="cableBridgeExpandKeys"
            @row-click="handleTablerowClick($event, 3)"
          >
            <el-table-column align="left" prop="frontDisplayName" label="类型" min-width="120px">
              <template #default="{ row }">
                <span v-if="!row.isEdit">{{ row.frontDisplayName }}</span>
                <el-input v-else v-model="row.frontDisplayName" :class="'input' + row.ruleDetailsId" style="width: 80%" size="small"></el-input>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="layerId" label="图层" width="150px">
              <template #default="{ row }">
                <el-select v-model="row.layerId" placeholder="请选择" filterable clearable size="small" @change="layerChange($event, row)">
                  <el-option v-for="item in layer[row.specId]" :key="item.layerId" :value="item.layerId" :label="item.layerName"></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="colour" label="颜色">
              <template #default="{ row }">
                <span v-if="row.colour !== null" class="colorBlock" :class="'color' + row.colour"></span>
                <span>
                  {{ row.colour }}
                </span>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="lineTypeName" label="线型"> </el-table-column>
          </el-table>
          <div class="operator">
            <el-button type="primary" size="small" plain @click="addTableData(3)">新增</el-button>
            <el-button type="danger" size="small" plain @click="handleDelKeywordTable(3)">删除</el-button>
          </div>
        </div>
      </div>
    </div>
    <div class="mainOperator">
      <el-button size="small" @click="handleCancel">取消</el-button>
      <el-button type="primary" size="small" @click="handleSave">保存</el-button>
    </div>
  </div>
</template>

<script>
import revitSetService from "@/CommonDP/service/revitSet-service";
import { mapState } from "vuex";
import * as cloneDeep from "lodash/cloneDeep";
export default {
  data() {
    return {
      layer: {},
      professionalList: [],
      filterList: [],
      layoutAttrList: {},
      buildingTypeTableData: [], // 构件数据
      rawBuildingTypeTableData: [],
      keywordTableData: [],
      rawKeywordTableData: [],
      pipelineTableData: [],
      rawPipelineTableData: [],
      airLineTableData: [],
      rawAirLineTableData: [],
      cableBridgeTableData: [],
      rawCableBridgeTableData: [],
      curKeywordRow: {},
      curPipelineRow: {},
      curAirLineRow: {},
      curCableBridgeRow: {},
      ruleId: "",
      pipelineExpandKeys: [],
      airLineExpandKeys: [],
      cableBridgeExpandKeys: []
    };
  },
  computed: {
    ...mapState({
      prjInfo: (state) => state.projectMg.prjObj,
      enterpriseId: (state) => state.enterprise.enterpriseId
    })
  },
  watch: {
    layer(val) {
      console.log("layer", this.layer);
    }
  },
  created() {
    this.init();
  },
  methods: {
    async init() {
      this.getFilterList();
      this.getProfessionalList();
      await this.getRevitSettingsDicList();
      // this.getRevitSettingsList("test1");
    },
    specChange($event, row) {
      console.log($event, row);
      row.specName = this.professionalList.find((item) => item.specId === row.specId).specName;
      this.getCategoriesList(row.specId);
      row.layerName = "";
      row.layerId = "";
      row.colour = "";
      row.lineTypeId = "";
      row.lineTypeName = "";
    },
    filterRuleChange($event, row) {
      row.filterConditionName = this.filterList.find((item) => item.id === row.filterConditionId).cnName;
    },
    // 过滤规则
    getFilterList() {
      revitSetService.getDicList("FilterCondition").then((res) => {
        this.filterList = res.data;
      });
    },
    // 右侧-获取默认族
    async getRevitSettingsDicList() {
      await revitSetService.getRevitSettingsDicList(this.enterpriseId).then((res) => {
        Object.values(res.data).map((arr) => {
          arr.map((value) => {
            value.frontDisplayName = value.cnName;
            value.layerId = "";
            value.layerName = "";
            value.lineTypeName = "";
            value.lineTypeId = "";
            value.colour = "";
          });
        });
        this.layoutAttrList = res.data;
      });
    },
    formatterData(arr, item) {
      const obj = { children: [], frontDisplayName: "", ruleDetailsId: "", lineTypeName: "", colour: "", layerId: "", specName: "", specId: "" };
      obj.specName = item.specName;
      obj.specId = item.specId;
      obj.frontDisplayName = obj.inputValue = item.inputValue;
      obj.ruleDetailsId = `${Math.floor(Math.random() * 90000) + 10000}${item.id}`;
      obj.children.push(item);
      obj.isEdit = true;
      arr.push(obj);
    },
    // 右侧列表
    async getRevitSettingsList(id) {
      this.ruleId = id;
      const res = await revitSetService.getRevitSettingsList(id);
      this.buildingTypeTableData = [];
      this.keywordTableData = [];
      this.pipelineTableData = [
        { children: [], frontDisplayName: "给排水", ruleDetailsId: "0002", lineTypeName: "", colour: "", layerId: "", specName: "", specId: "" },
        { children: [], frontDisplayName: "暖通空调", ruleDetailsId: "0001", lineTypeName: "", colour: "", layerId: "", specName: "", specId: "" }
      ];
      this.airLineTableData = [];
      this.cableBridgeTableData = [
        { children: [], frontDisplayName: "强电", ruleDetailsId: "0001", lineTypeName: "", colour: "", layerId: "", specName: "", specId: "" },
        { children: [], frontDisplayName: "弱电", ruleDetailsId: "0002", lineTypeName: "", colour: "", layerId: "", specName: "", specId: "" }
      ];
      var arr, target;
      res.data?.map((item) => {
        item.frontDisplayName = item.familyCategoryName;
        switch (item.confType) {
          case 1:
            this.buildingTypeTableData.push(item);
            break;
          case 2:
            this.keywordTableData.push(item);
            break;
          case 3:
            arr = this.pipelineTableData[0].children;
            target = arr.find((arrItem) => arrItem.inputValue === item.inputValue);
            if (target) {
              target.children.push(item);
            } else {
              this.formatterData(arr, item, true);
            }
            this.pipelineTableData[0].specName = item.specName;
            this.pipelineTableData[0].specId = item.specId;
            break;
          case 4:
            arr = this.pipelineTableData[1].children;
            target = arr.find((arrItem) => arrItem.inputValue === item.inputValue);
            if (target) {
              target.children.push(item);
            } else {
              this.formatterData(arr, item, true);
            }
            this.pipelineTableData[1].specName = item.specName;
            this.pipelineTableData[1].specId = item.specId;
            break;
          case 5:
            arr = this.airLineTableData;
            target = arr.find((arrItem) => arrItem.inputValue === item.inputValue);
            if (target) {
              target.children.push(item);
            } else {
              this.formatterData(arr, item, true);
            }
            break;
          case 6:
            arr = this.cableBridgeTableData[0].children;
            target = arr.find((arrItem) => arrItem.inputValue === item.inputValue);
            if (target) {
              target.children.push(item);
            } else {
              this.formatterData(arr, item, true);
            }
            this.cableBridgeTableData[0].specName = item.specName;
            this.cableBridgeTableData[0].specId = item.specId;
            break;
          case 7:
            arr = this.cableBridgeTableData[1].children;
            target = arr.find((arrItem) => arrItem.inputValue === item.inputValue);
            if (target) {
              target.children.push(item);
            } else {
              this.formatterData(arr, item, true);
            }
            this.cableBridgeTableData[1].specName = item.specName;
            this.cableBridgeTableData[1].specId = item.specId;
            break;
          default:
            break;
        }
      });
      // 给排水  PLUM暖通  MECH电气  ELEC
      const fixedSpec = ["PLUM", "MECH", "ELEC"].map((templateSpecId) => {
        return this.professionalList.find((item) => item.templateSpecId === templateSpecId);
      });
      [this.buildingTypeTableData, this.keywordTableData, fixedSpec].map((tableData, index) => {
        tableData.map((item, idx) => {
          !item.specId && console.log(index, idx);
          this.getCategoriesList(item.specId);
        });
      });
      this.rawBuildingTypeTableData = cloneDeep(this.buildingTypeTableData);
      this.rawKeywordTableData = cloneDeep(this.keywordTableData);
      this.rawPipelineTableData = cloneDeep(this.pipelineTableData);
      this.rawAirLineTableData = cloneDeep(this.airLineTableData);
      this.rawCableBridgeTableData = cloneDeep(this.cableBridgeTableData);
    },
    convertData(data) {
      let key = "";
      switch (data.confType) {
        case 3:
        case 4:
          key = "pipingSystem";
          break;
        case 5:
          key = "airDuctSystem";
          break;
        case 6:
        case 7:
          key = "cableTray";
          break;
        default:
          break;
      }
      data.children = cloneDeep(this.layoutAttrList[key]).map((item) => {
        const child = cloneDeep(data);
        child.familyCategoryId = item.id;
        child.frontDisplayName = child.familyCategoryName = item.cnName;
        child.ruleDetailsId = `${Math.floor(Math.random() * 90000) + 10000}${item.id}`;
        child.isEdit = false;
        return child;
      });
    },
    // 图层专业列表(新)
    getProfessionalList() {
      revitSetService.getProfessionalList(this.enterpriseId).then((res) => {
        this.professionalList = res.data;
      });
    },
    async getCategoriesList(code) {
      if (!this.layer[code]) {
        this.$set(this.layer, code, []);
        return revitSetService.getCategoriesList(this.enterpriseId, code).then((res) => {
          this.layer[code] = res.data;
        });
      }
    },
    handleTablerowClick(data, type) {
      switch (type) {
        case 0:
          this.curKeywordRow = data;
          break;
        case 1:
          this.curPipelineRow = data;
          break;
        case 2:
          this.curAirLineRow = data;
          break;
        case 3:
          this.curCableBridgeRow = data;
          break;
        default:
          break;
      }
    },
    handleDelKeywordTable(type) {
      const map = {
        0: this.keywordTableData,
        1: this.pipelineTableData,
        2: this.airLineTableData,
        3: this.cableBridgeTableData
      };
      const curRowMap = {
        0: this.curKeywordRow,
        1: this.curPipelineRow,
        2: this.curAirLineRow,
        3: this.curCableBridgeRow
      };
      let dataList = [];
      if ([0, 2].includes(type)) {
        dataList = map[type];
      } else {
        map[type].map((item) => {
          item.children.map((item) => {
            dataList.push(item);
          });
        });
      }
      const index = dataList.findIndex((item) => item.ruleDetailsId === curRowMap[type].ruleDetailsId);
      console.log(index);
      if (index > -1) {
        this.$confirm("确认删除?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            if ([0, 2].includes(type)) {
              map[type].splice(index, 1);
            } else {
              const leng1 = map[type][0].children.length;
              if (leng1 > index) {
                map[type][0].children.splice(index, 1);
              } else {
                map[type][1].children.splice(index - leng1, 1);
              }
            }
          })
          .catch(() => {
            console.log("取消删除");
          });
      } else {
        return this.$warn("请先选中列表中的数据");
      }
    },
    async addTableData(type) {
      const map = {
        0: this.keywordTableData,
        1: this.pipelineTableData,
        2: this.airLineTableData,
        3: this.cableBridgeTableData
      };
      const curRowMap = {
        0: this.curKeywordRow,
        1: this.curPipelineRow,
        2: this.curAirLineRow,
        3: this.curCableBridgeRow
      };
      const expandKeys = {
        1: this.pipelineExpandKeys,
        2: this.airLineExpandKeys,
        3: this.cableBridgeExpandKeys
      };
      const tableDomMap = {
        0: "keywordDom",
        1: "pipeLineDom",
        2: "airLineDom",
        3: "cableBridgeDom"
      };

      let confType;
      let dataList = [];
      if ([0, 2].includes(type)) {
        dataList = map[type];
        confType = type === 0 ? 2 : 5;
      } else {
        dataList = map[type].find((item, index) => {
          if (item.ruleDetailsId === curRowMap[type].ruleDetailsId) {
            if (type === 1) {
              confType = index === 0 ? 3 : 4;
            } else if (type === 3) {
              confType = index === 0 ? 6 : 7;
            }
            return true;
          }
          return false;
        })?.children;
      }
      if (dataList) {
        const rawObj = {
          colour: 0,
          conditionId: "",
          conditionName: "",
          confType: 0,
          familyCategoryId: "",
          familyCategoryName: "",
          filterConditionId: "",
          filterConditionName: "",
          filterId: "",
          filterName: "",
          inputValue: "",
          isDelete: 0,
          layerId: "",
          layerName: "",
          lineTypeId: 0,
          lineTypeName: "",
          lineWidthId: "",
          lineWidthValue: "",
          operDate: "",
          operUserId: "",
          operUserName: "",
          orderNum: 0,
          ruleDetailsId: "",
          ruleId: "",
          specId: "",
          specName: ""
        };
        rawObj.confType = confType;
        rawObj.isEdit = true;
        rawObj.ruleDetailsId = Math.floor(Math.random() * 900000) + 100000;
        rawObj.ruleId = this.ruleId;

        if ([1, 2, 3].includes(type)) {
          // 给排水  PLUM暖通  MECH电气  ELEC
          const spec = this.getAddRowSpec(confType);
          rawObj.specId = spec.specId;
          rawObj.specName = spec.specName;
          this.convertData(rawObj);
          setTimeout(() => {
            console.log(this.$refs[tableDomMap[type]]);
            const dom = this.$refs[tableDomMap[type]].$el.querySelector(`.input${rawObj.ruleDetailsId} .el-input__inner`);
            console.log(dom);
            dom?.focus();
          }, 700);
        }
        dataList.push(rawObj);
        await this.$nextTick();
        if ([0, 2].includes(type)) {
          this.$refs[tableDomMap[type]].$el.querySelector(".el-table__body-wrapper").scrollTop = 9999;
        }
        expandKeys[type]?.push(curRowMap[type].ruleDetailsId, rawObj.ruleDetailsId);
      } else {
        return this.$warn("请先选中一个顶级类型");
      }
    },
    getAddRowSpec(type) {
      let name;
      switch (type) {
        case 3:
          name = "PLUM";
          break;
        case 4:
        case 5:
          name = "MECH";
          break;
        case 6:
        case 7:
          name = "ELEC";
          break;
        default:
          break;
      }
      return this.professionalList.find((item) => item.templateSpecId === name);
    },
    handleMove(isDown) {
      const index = this.keywordTableData.indexOf(this.curKeywordRow);
      if (index === -1) {
        return this.$warn("请先选中列表中的数据");
      } else {
        const length = this.keywordTableData.length;
        if (isDown) {
          if (index === length - 1) {
            return this.$warn("最后一列不可下移");
          }
          this.keywordTableData.splice(index, 1);
          this.keywordTableData.splice(index + 1, 0, this.curKeywordRow);
        } else {
          if (index === 0) {
            return this.$warn("最后一列不可上移");
          }
          this.keywordTableData.splice(index, 1);
          this.keywordTableData.splice(index - 1, 0, this.curKeywordRow);
        }
      }
    },
    async handleSave() {
      const params = [];
      [this.buildingTypeTableData, this.keywordTableData, this.pipelineTableData, this.airLineTableData, this.cableBridgeTableData].map((tableData, index) => {
        tableData.map((item) => {
          switch (index) {
            case 0:
            case 1:
              params.push(item);
              break;
            case 2:
            case 4:
              item.children?.map((spec) => {
                spec.children?.map((layer) => {
                  layer.inputValue = spec.frontDisplayName;
                  params.push(layer);
                });
              });
              break;
            case 3:
              item.children?.map((layer) => {
                layer.inputValue = item.frontDisplayName;
                params.push(layer);
              });
              break;
            default:
              break;
          }
        });
      });
      console.log(JSON.parse(JSON.stringify(params)));
      await this.$confirm("指定的规则图层不能为空，请核查后提交", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      });
      revitSetService.saveRightTables(params).then((res) => {
        this.$message.success("保存成功");
        this.getRevitSettingsList(this.ruleId);
      });
    },
    handleCancel() {
      this.buildingTypeTableData = cloneDeep(this.rawBuildingTypeTableData);
      this.keywordTableData = cloneDeep(this.rawKeywordTableData);
      this.pipelineTableData = cloneDeep(this.rawPipelineTableData);
      this.airLineTableData = cloneDeep(this.rawAirLineTableData);
      this.cableBridgeTableData = cloneDeep(this.rawCableBridgeTableData);
    },
    async layerChange(event, row) {
      const target = this.layer[row.specId].find((item) => item.layerId === event);
      row.layerName = target.layerName;
      row.colour = target.colour;
      row.lineTypeId = target.lineTypeId;
      row.lineTypeName = target.lineType;
    },
    // 刷新右侧表格
    refreshTable() {
      this.$refs.rightTable.getRuleRightData();
    },
    // 设置右侧表中当前规则
    setCurrentRule(row) {
      this.currentRule = row;
    },
    firstLayoutSpanMethod({ row, column, rowIndex, columnIndex }) {
      const isMerge = this.airLineTableData.some((first) => first.ruleDetailsId === row.ruleDetailsId);
      if (isMerge) {
        return [1, 4];
      } else {
        return [1, 1];
      }
    },
    secondLayoutSpanMethod({ row, column, rowIndex, columnIndex }) {
      // console.log(this.pipelineTableData.indexOf(row));
      const isMerge = this.pipelineTableData.some(
        (first) => first.ruleDetailsId === row.ruleDetailsId || first.children?.some((second) => second.ruleDetailsId === row.ruleDetailsId)
      );
      if (isMerge) {
        return [1, 4];
      }
    },
    secondLayoutSpanMethod2({ row, column, rowIndex, columnIndex }) {
      const isMerge = this.cableBridgeTableData.some(
        (first) => first.ruleDetailsId === row.ruleDetailsId || first.children?.some((second) => second.ruleDetailsId === row.ruleDetailsId)
      );
      if (isMerge) {
        return [1, 4];
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "./revitColor.scss";
</style>

<style lang="scss" scoped>
.top {
  display: flex;
  justify-content: space-around;
  .half {
    width: calc(50% - 18px);
    border: 1px solid #e5e8f1;
    border-radius: 5px;
    position: relative;
    padding: 22px 12px;
  }
  .table {
    height: 250px;
    overflow: auto;
  }
  .operator {
    display: flex;
    margin-top: 10px;
  }
}
.bottom {
  display: flex;
  margin-top: 24px;
  justify-content: space-around;
  .third {
    width: calc(33.333% - 16px);
    border: 1px solid #e5e8f1;
    border-radius: 5px;
    position: relative;
    padding: 20px;
    // padding: 0 1.5%;
  }
}
.title {
  position: absolute;
  padding: 0 5px;
  top: -9px;
  left: 15px;
  background: #fff;
}
.ruleRight {
  width: 100%;
  height: 100%;
  .rightTable {
    overflow: auto;
    width: 100%;
    height: calc(100% - 50px);
    padding: 20px 0;
  }
}

.colorBlock {
  display: inline-block;
  width: 14px;
  height: 14px;
  margin-right: 6px;
  border-radius: 2px;
  vertical-align: middle;
  border: 1px solid #f3f3f3;
}

.mainOperator {
  display: flex;
  justify-content: flex-end;
  padding: 0 30px;
  border-top: 1px solid #fefefe;
  justify-content: flex-end;
}

.pipeLine {
  ::v-deep .el-table__row--level-1 .cell {
    text-align: left !important;
    height: 40px;
    line-height: 40px;
  }
  ::v-deep .el-table__row--level-0 .cell {
    text-align: left !important;
    height: 40px;
    line-height: 40px;
  }
}

.airLine {
  ::v-deep .el-table__row--level-0 .cell {
    text-align: left !important;
    height: 40px;
    line-height: 40px;
  }
}

::v-deep .el-input__inner {
  border: none;
  box-shadow: none;
  font-size: 12px;
}
::v-deep .el-table .el-table__cell {
  padding: 3px 0;
}
</style>
